const t = "{{currentTime}} sur {{duration}}", e = "{{current}} résultats de recherche sur {{total}}", n = "Aucun résultat trouvé", s = "{{count}} résultat trouvé", o = "{{count}} résultats trouvés", c = 'Lecture en cours depuis $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) et $t(SECONDS, { "count": {{seconds}} }).', r = 'Lecture en cours depuis $t(MINUTES, { "count": {{minutes}} }) et $t(SECONDS, { "count": {{seconds}} }).', u = 'Lecture en cours depuis $t(SECONDS, { "count": {{seconds}} }).', A = "Erreur lors de l’enregistrement des modifications de la transcription.", i = "Ligne de transcription à {{time}}. Le contenu est : {{text}}.", E = 'Conteneur de lignes de transcription. Il y a $t(TRANSCRIPT_LINES, { "count": {{count}} }) dans ce conteneur. Pour naviguer dans ce conteneur, utilisez la touche Flèche descendante.', T = "Sauvegarde des modifications en cours...", _ = "Modifications de la transcription enregistrées.", S = "Le bouton de mise à jour des sous-titres est désormais disponible.", a = "Action", R = "Ajouter une annotation à {{time}}", N = "Ajouter une question à {{time}}", O = "Annotations", I = "Auto", C = "Auto ({{quality}})", d = "Retour", l = "Sous-titres", P = "Langue des sous-titres", L = "Gérer les sous-titres", U = "Supprimer {{language}}", D = "Taille de police", M = "Langue de sous-titrage : {{language}}", m = "{{language}} (automatique)", p = "Réinitialiser la recherche", h = "Fermer", g = "Commentaires", G = "Continuer", Y = "Réduire vitesse de lecture", v = "Réduire volume de {{percent}}%", V = "Flèche bas", H = "Fermer l’éditeur de transcription", F = "Mettre à jour les sous-titres", B = "Erreur !", K = "Enregistrement en cours...", f = "Enregistrement terminé.", Q = "Modifier la transcription", x = "Le champ Texte ne peut pas être vide.", W = "Plein écran", $ = "{{count}} heure", q = "{{count}} heures", j = "Augmenter vitesse de lecture", J = "Augmenter volume de {{percent}}%", b = "Inverser couleurs", y = "Accéder à un pourcentage spécifique (1-10 %, 2-20 %, etc.)", z = "Accéder à Démarrer", Z = "Actions pour {{title}}", X = "Raccourcis clavier", k = "Langue", w = "Flèche gauche", tt = "Menu principal", et = "{{count}} minute", nt = "{{count}} minutes", st = "Passer en silencieux", ot = "Mode silencieux", ct = "Langue de sous-titrage suivante", rt = "Résultat de recherche suivant", ut = "Désactiver", At = "Au-dessus", it = "Ouvrir une annotation à {{time}}", Et = "Ouvrir le quiz complété à {{time}}", Tt = "Ouvrir un quiz à {{time}}", _t = "Mettre en pause", St = "Lecture", at = "Vitesse de lecture", Rt = "Vitesse de lecture : {{speed}}x", Nt = "Langue de sous-titrage précédente", Ot = "Résultat de recherche précédent", It = "Qualité", Ct = "Menu Qualité", dt = "Rejouer", lt = "Réinitialiser vitesse de lecture", Pt = "Flèche droite", Lt = "Rechercher dans la transcription", Ut = "{{count}} seconde", Dt = "{{count}} secondes", Mt = "Recherche arrière : {{seconds}} secondes", mt = "Recherche avant : {{seconds}} secondes", pt = "Paramètres", ht = "Raccourci", gt = "Détails et outils média", Gt = "Espacer", Yt = "Menu Vitesse de lecture", vt = "Démarrer défilement auto", Vt = "Activer les sous-titres", Ht = "Bouton Silencieux", Ft = "Bouton Lecture/Pause", Bt = "a {{count}} ligne de transcription", Kt = "a {{count}} lignes de transcription", ft = "Chargement de la transcription...", Qt = "Nous n’avons pas pu charger la transcription.", xt = "Options de transcription", Wt = "Réessayer", $t = "Transcription indisponible", qt = "Flèche haut", jt = "Paramètres vidéo", Jt = "Volume", bt = "Volume : {{volume}}%", yt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: e,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: o,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: r,
  A11Y_TIMESTAMP_JUMP_SECONDS: u,
  A11Y_TRANSCRIPT_ERROR: A,
  A11Y_TRANSCRIPT_LINE: i,
  A11Y_TRANSCRIPT_LINES: E,
  A11Y_TRANSCRIPT_SAVING: T,
  A11Y_TRANSCRIPT_SUCCESS: _,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: S,
  ACTION: a,
  ADD_ANNOTATION_AT: R,
  ADD_QUESTION_AT: N,
  ANNOTATIONS: O,
  AUTO: I,
  AUTO_QUALITY: C,
  BACK: d,
  CAPTIONS: l,
  CAPTIONS_LANGUAGE: P,
  CAPTIONS_MANAGE: L,
  CAPTION_DELETE: U,
  CAPTION_FONT_SIZE: D,
  CAPTION_LANGUAGE: M,
  CAPTION_LANGUAGE_AUTOMATIC: m,
  CLEAR_SEARCH: p,
  CLOSE: h,
  COMMENTS: g,
  CONTINUE: G,
  DECREASE_PLAYBACK_SPEED: Y,
  DECREASE_VOLUME: v,
  DOWN_ARROW: V,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: F,
  EDIT_ERROR: B,
  EDIT_SAVING: K,
  EDIT_SUCCESS: f,
  EDIT_TRANSCRIPT: Q,
  EDIT_VALIDATION_ERROR: x,
  FULLSCREEN: W,
  HOURS: $,
  HOURS_other: q,
  INCREASE_PLAYBACK_SPEED: j,
  INCREASE_VOLUME: J,
  INVERT_COLORS: b,
  JUMP_TO_PERCENTAGE: y,
  JUMP_TO_START: z,
  KEBAB_MENU: Z,
  KEYBOARD_SHORTCUTS: X,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: tt,
  MINUTES: et,
  MINUTES_other: nt,
  MUTE: st,
  MUTED: ot,
  NEXT_CAPTION_LANGUAGE: ct,
  NEXT_HIT: rt,
  OFF: ut,
  ON_TOP: At,
  OPEN_ANNOTATION_AT: it,
  OPEN_COMPLETED_QUIZ_AT: Et,
  OPEN_QUIZ_AT: Tt,
  PAUSE: _t,
  PLAY: St,
  PLAYBACK_SPEED: at,
  PLAYBACK_SPEED_MESSAGE: Rt,
  PREVIOUS_CAPTION_LANGUAGE: Nt,
  PREVIOUS_HIT: Ot,
  QUALITY: It,
  QUALITY_MENU: Ct,
  REPLAY: dt,
  RESET_PLAYBACK_SPEED: lt,
  RIGHT_ARROW: Pt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Lt,
  SECONDS: Ut,
  SECONDS_other: Dt,
  SEEK_BACKWARD: Mt,
  SEEK_FORWARD: mt,
  SETTINGS: pt,
  SHORTCUT: ht,
  SIDEBAR: gt,
  SPACE: Gt,
  SPEED_MENU: Yt,
  START_AUTOSCROLL: vt,
  TOGGLE_CAPTIONS: Vt,
  TOGGLE_MUTED: Ht,
  TOGGLE_PLAY_PAUSE: Ft,
  TRANSCRIPT_LINES: Bt,
  TRANSCRIPT_LINES_other: Kt,
  TRANSCRIPT_LOADING: ft,
  TRANSCRIPT_LOAD_ERROR: Qt,
  TRANSCRIPT_OPTIONS: xt,
  TRANSCRIPT_RETRY: Wt,
  TRANSCRIPT_UNAVAILABLE: $t,
  UP_ARROW: qt,
  VIDEO_SETTINGS: jt,
  VOLUME: Jt,
  VOLUME_VALUE: bt
};
export {
  t as A11Y_DURATION,
  e as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  o as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  r as A11Y_TIMESTAMP_JUMP_MINUTES,
  u as A11Y_TIMESTAMP_JUMP_SECONDS,
  A as A11Y_TRANSCRIPT_ERROR,
  i as A11Y_TRANSCRIPT_LINE,
  E as A11Y_TRANSCRIPT_LINES,
  T as A11Y_TRANSCRIPT_SAVING,
  _ as A11Y_TRANSCRIPT_SUCCESS,
  S as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  a as ACTION,
  R as ADD_ANNOTATION_AT,
  N as ADD_QUESTION_AT,
  O as ANNOTATIONS,
  I as AUTO,
  C as AUTO_QUALITY,
  d as BACK,
  l as CAPTIONS,
  P as CAPTIONS_LANGUAGE,
  L as CAPTIONS_MANAGE,
  U as CAPTION_DELETE,
  D as CAPTION_FONT_SIZE,
  M as CAPTION_LANGUAGE,
  m as CAPTION_LANGUAGE_AUTOMATIC,
  p as CLEAR_SEARCH,
  h as CLOSE,
  g as COMMENTS,
  G as CONTINUE,
  Y as DECREASE_PLAYBACK_SPEED,
  v as DECREASE_VOLUME,
  V as DOWN_ARROW,
  H as EDIT_CLOSE,
  F as EDIT_CONFIRM,
  B as EDIT_ERROR,
  K as EDIT_SAVING,
  f as EDIT_SUCCESS,
  Q as EDIT_TRANSCRIPT,
  x as EDIT_VALIDATION_ERROR,
  W as FULLSCREEN,
  $ as HOURS,
  q as HOURS_other,
  j as INCREASE_PLAYBACK_SPEED,
  J as INCREASE_VOLUME,
  b as INVERT_COLORS,
  y as JUMP_TO_PERCENTAGE,
  z as JUMP_TO_START,
  Z as KEBAB_MENU,
  X as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  tt as MAIN_MENU,
  et as MINUTES,
  nt as MINUTES_other,
  st as MUTE,
  ot as MUTED,
  ct as NEXT_CAPTION_LANGUAGE,
  rt as NEXT_HIT,
  ut as OFF,
  At as ON_TOP,
  it as OPEN_ANNOTATION_AT,
  Et as OPEN_COMPLETED_QUIZ_AT,
  Tt as OPEN_QUIZ_AT,
  _t as PAUSE,
  St as PLAY,
  at as PLAYBACK_SPEED,
  Rt as PLAYBACK_SPEED_MESSAGE,
  Nt as PREVIOUS_CAPTION_LANGUAGE,
  Ot as PREVIOUS_HIT,
  It as QUALITY,
  Ct as QUALITY_MENU,
  dt as REPLAY,
  lt as RESET_PLAYBACK_SPEED,
  Pt as RIGHT_ARROW,
  Lt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  Ut as SECONDS,
  Dt as SECONDS_other,
  Mt as SEEK_BACKWARD,
  mt as SEEK_FORWARD,
  pt as SETTINGS,
  ht as SHORTCUT,
  gt as SIDEBAR,
  Gt as SPACE,
  Yt as SPEED_MENU,
  vt as START_AUTOSCROLL,
  Vt as TOGGLE_CAPTIONS,
  Ht as TOGGLE_MUTED,
  Ft as TOGGLE_PLAY_PAUSE,
  Bt as TRANSCRIPT_LINES,
  Kt as TRANSCRIPT_LINES_other,
  ft as TRANSCRIPT_LOADING,
  Qt as TRANSCRIPT_LOAD_ERROR,
  xt as TRANSCRIPT_OPTIONS,
  Wt as TRANSCRIPT_RETRY,
  $t as TRANSCRIPT_UNAVAILABLE,
  qt as UP_ARROW,
  jt as VIDEO_SETTINGS,
  Jt as VOLUME,
  bt as VOLUME_VALUE,
  yt as default
};
